import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

class Line extends React.PureComponent {
  static getFilledStyle(from, to) {
    const leftValue = 100 * from;
    const rightValue = 100 - 100 * to;
    return {
      left: `${leftValue}%`,
      right: `${rightValue}%`,
    };
  }

  render() {
    return (
      <S.LineWrapper layout={this.props.layout}>
        <S.Line
          invalid={this.props.invalid}
          style={Line.getFilledStyle(this.props.from, this.props.to)}
        />
      </S.LineWrapper>
    );
  }
}

Line.propTypes = {
  layout: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  invalid: PropTypes.bool.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
};

export default Line;
